import { IconButton } from "@material-ui/core";
import { AttachFileOutlined, CancelOutlined } from "@material-ui/icons";
import React from "react";
import { allowedFileExtensions } from "../../constants/appConstants";
import "../../components/common/sharepoint-upload/index.less";
export default class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: props.fileName,
      formData: props.formData,
      reload: props.reload
    };
  }
  static getDerivedStateFromProps(newProps, state) {
    if (
      newProps.fileName !== state.fileName ||
      newProps.formData !== state.formData ||
      newProps.reload !== state.reload
    ) {
      return {
        reload: newProps.reload,
        fileName: newProps.fileName,
        formData: newProps.formData
      };
    }
    return null;
  }
  render() {
    return (
      <>
        <div className={"row col-xs-12"}>
          <div className={"col-xs-3 image-upload"}>
            <label htmlFor={"file-input"} className={"attachment-btn"}>
              {/* <IconButton> */}
              <span>
                {" "}
                <AttachFileOutlined fontSize={"inherit"} />{" "}
                <span>{"Add Attachment"}</span>
              </span>
              {/* <AttachFileOutlined /> */}
              {/* </IconButton> */}
            </label>

            <input
              id={"file-input"}
              type={"file"}
              multiple
              accept={allowedFileExtensions}
              onChange={e => {
                this.props.onChange(e);
              }}
            />
          </div>
          <div className={"col-xs-9"}>
            {this.state.fileName.length > 0 && (
              <div className={"row fileUpload-div"}>
                {this.state.fileName.map(file => (
                  <span className={"file-uploadSpan"} key={file}>
                    {file}
                    <IconButton
                      size={"small"}
                      onClick={() => this.props.deleteFile(file)}
                    >
                      <CancelOutlined fontSize={"inherit"} />
                    </IconButton>
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}
